import { useState } from "react";

import { ModalViewProduct } from "Pages/Product/Modals/ViewProduct";

import { Product } from "Hooks/useProducts/interface";

import { Button } from "Components/Button";
import AtentionIcon from "Assets/Images/atention.svg";
import { Modal } from "Components/Modals/Modal";
import { Box } from "styles/globalComponents";
import { CardProduct } from "Components/PreOrder/CardProduct";
import { useItemsContext } from "Pages/PreBudgetConvertion/hooks/useItemsContext";
import { ContainerProductList } from "./styles";
import { useCartAmount } from "../../hooks/useCartAmount";

interface ProductsListResultProps {
  productsList: Product[];
}

export const ProductsListResult = ({
  productsList,
}: ProductsListResultProps) => {
  const [modalViewInfoProduct, setModalViewInfoProduct] = useState(false);
  const [productDetailId, setProductDetailId] = useState<null | number>(null);

  const openProductDetails = (productDetailIdd: number) => {
    setProductDetailId(productDetailIdd);
    setModalViewInfoProduct(true);
  };

  const {
    handleAddProduct,
    handleRemoveToCart,
    closeModal,
    modal,
    preparation,
    preparationConfirmCallback,
    setPreparationConfirmCallback,
  } = useCartAmount();

  const { items, blockUserInteraction } = useItemsContext();

  const proceedAddProduct = () => {
    if (preparationConfirmCallback.resolved)
      preparationConfirmCallback.resolved();
    setPreparationConfirmCallback({ rejected: null, resolved: null });
    closeModal("alerts");
  };

  const cancelAddProduct = () => {
    if (preparationConfirmCallback.rejected)
      preparationConfirmCallback.rejected();
    setPreparationConfirmCallback({ rejected: null, resolved: null });
    closeModal("alerts");
  };

  return (
    <>
      <ContainerProductList className="products-results">
        <table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>PRODUTO</th>
              <th>SINONÍMIA</th>
              <th>VALOR</th>
              <th>AÇÕES</th>
            </tr>
          </thead>

          <tbody>
            {productsList.map((product) => (
              <CardProduct
                key={product.id}
                product={product}
                addToCart={() => handleAddProduct(product)}
                removeToCart={() => handleRemoveToCart(product)}
                blockUserInteraction={blockUserInteraction}
                isProductAlredyInCart={
                  !!items.some((d) => d.product_id === product.id)
                }
              >
                <Button
                  outlined
                  onClick={() => openProductDetails(product.id)}
                  disabled={blockUserInteraction}
                >
                  {" "}
                  Saiba Mais
                </Button>
              </CardProduct>
            ))}
          </tbody>
        </table>
      </ContainerProductList>

      <Modal
        isOpen={modal.alerts}
        requestClose={cancelAddProduct}
        closeOverlay
        modalIcon={AtentionIcon}
        renderHeading={() => <h2>Alerta</h2>}
        renderDescription={() => <p>{preparation}</p>}
        renderActions={() => (
          <Box>
            <Box display="flex" justify="center" mt="30">
              <Button minHeight="40px" onClick={proceedAddProduct}>
                Adicionar produto
              </Button>

              <Button minHeight="40px" outlined onClick={cancelAddProduct}>
                Cancelar adição do produto
              </Button>
            </Box>
          </Box>
        )}
      />

      <ModalViewProduct
        openModal={modalViewInfoProduct}
        closeModal={() => setModalViewInfoProduct(false)}
        idSelected={productDetailId}
      />
    </>
  );
};
